// extracted by mini-css-extract-plugin
module.exports = {"description":"ApiCard_description__3lwGt","card":"ApiCard_card__zErD0","icon":"ApiCard_icon__rDtsI"};